export default __webpack_public_path__ + "stick-80c4230a247ca99fe266e31381ac60ed.mp3";